import React, { useMemo, useContext } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { AgGridReact } from '@ag-grid-community/react';
import { defaultGridHeight } from './utils';
import { usePaymentTermsContext } from 'contexts/CategoryInsightsKpi/PaymentTermsProvider';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';

const PaymentTermsExplore = () => {
	const { gridData } = usePaymentTermsContext();
	const { paymentTerms: days } = useContext(CategoryInsightsSettingsContext);
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of vendors with DPO less than ${days} days.`}
				</AnalysisDescription>
				<TableContainer>
					<div style={gridStyle} className="ag-theme-balham">
						<AgGridReact {...gridData} />
					</div>
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default PaymentTermsExplore;
